import React from 'react';
import '../styles/BlogStyles/BlogStyles.css';
import { Link } from 'react-router-dom';
import blog from "../assets/blog.jpeg";
import bloglist from "../assets/blog1.jpeg";
import bloglist2 from "../assets/blog2.jpeg";


const BlogList = () => {
  const blogPosts = [
    {
      id: 1,
      title: "BREAKING: CA Results Date Announced! | November 3, 2025",
      desc: "The Institute of Chartered Accountants of India just dropped the official announcement that CA students across the country have been waiting for.",
      img:bloglist,
      link: "/blog/ca-results-announced"
    },
    {
      id: 2,
      title: "Your Roadmap to Success in CA, CMA & CS",
      desc: "If you are aspiring to become a Chartered Accountant (CA), Cost accountant, or Company Secretary, having a clear roadmap is essential for success.",
      img:bloglist2,
      link: "/blog/roadmap-to-success"
    },
    
  ];

  return (
    <div className="blog-page-wrapper">
      
      {/* 1. Hero Section */}
      <section className="blog-hero position-relative">
        <img 
          src={blog} 
          alt="Blog Header" 
          className="w-100 img-fluid blog-hero-img"
        />
        <div className="blog-hero-overlay"></div>
      </section>

      {/* 2. Blog Post Grid */}
      <section className="container py-5">
        <div className="row g-4 justify-content-center"> 
          
          {blogPosts.map((post) => (
            /* CHANGE: col-lg-4 creates 3 columns per row on large screens */
            <div key={post.id} className="col-12 col-md-6 col-lg-4"> 
              
              <div className="card h-100 custom-blog-card">
                {/* Image Wrapper */}
                <div className="card-img-wrapper">
                  <img 
                    src={post.img} 
                    alt={post.title} 
                    className="blog-card-img"
                  />
                </div>
                
                {/* Card Body */}
                <div className="card-body px-0 pb-0 d-flex flex-column">
                  <h5 className="card-title fw-bold text-dark mb-3">
                    {post.title}
                  </h5>
                  <p className="card-text text-muted mb-4 line-clamp-3">
                    {post.desc}
                  </p>
                  
                  {/* Button pushes to bottom */}
                  <div className="mt-auto">
                    <Link to={post.link} className="btn btn-purple">
                      Read More
                    </Link>
                  </div>
                </div>
              </div>

            </div>
          ))}

        </div>
      </section>

    </div>
  );
};

export default BlogList;